<!-- 替换为使用这里的icon，合约项目未使用bmui组件库 -->
<!-- 后续迭代更换 -->
<template>
  <i v-if="mode !== 'svg'" class="r-icon bmicon" :class="`${name}`" :style="{ fontSize: `${size}px` }"></i>
  <svg v-else class="r-icon" aria-hidden="true" :width="size" :height="size" :style="{ fontSize: size }">
    <use :xlink:href="`#${name}`" />
  </svg>
</template>
<script>
export default {
  name: 'RIcon',
  props: {
    /**
     * icon 名称
     */
    name: {
      type: String,
      default: '',
    },
    /**
     * 尺寸
     */
    size: {
      type: [Number,String],
      default: 16,
    },
    // 模式，svg | font-class
    mode: {
      type: String,
      default: 'font-class',
    },
  },
};
</script>
